import React from "react";
import EmptyState from "components/EmptyState";
import { useNavigate, useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import Retool from ".";
import EmptyStateOperationalEnergy from "features/OperationalEmissions/components/EmptyStateOperationalEnergy";
import { ROUTES_ENUM } from "routes/consts";
import { observer } from "mobx-react-lite";
import { operationalEmissionsStore } from "features/OperationalEmissions/OperationalEmissionsStore";
import { skeleton } from "utils";

const EnergyDashboard = () => {
  const reportID = "b3bb9696-a996-11ef-8b75-43d0d5d27c87";
  const { id: BuildingId } = useParams();
  const navigate = useNavigate();
  const [hasData, setHasData] = React.useState(false);
  const currentCertificate = buildingStore.getBuildingCertificationName();
  const [loading, setLoading] = React.useState(false);

  const embeddedData = {
    building_id: BuildingId,
  };

  async function checkHasData() {
    setLoading(true);
    if (!currentCertificate) return;
    await operationalEmissionsStore.fetchAllCertificationsData(
      buildingStore.buildingID
    );
    setHasData(
      !!operationalEmissionsStore.certificationsData?.[currentCertificate]
        ?.complete
    );
    setLoading(false);
  }

  React.useEffect(() => {
    checkHasData();
  }, [currentCertificate]);

  const openB6Dashboard = () => {
    navigate(
      `/${ROUTES_ENUM.BUILDINGS}/${buildingStore.currentBuilding?.id}/${ROUTES_ENUM.OPERATIONAL_ENERGY}`,
      { state: location.pathname }
    );
  };

  if (loading) return <div className="p-6">{skeleton("h-80")}</div>;

  if (!hasData)
    return (
      <EmptyStateOperationalEnergy
        isEnergyDashboard
        openSettings={openB6Dashboard}
        currentCertification={currentCertificate}
        isKeineCertificate={currentCertificate === "Keine"}
      />
    );

  if (!buildingStore.buildingMappingStatus.hasReport)
    return (
      <EmptyState
        type="inventory"
        loading={buildingStore.calculationsStatus.inProgress}
        containerClassName="m-6"
      />
    );

  return (
    <Retool
      url={reportID}
      embeddedData={embeddedData}
      className="h-[calc(100vh-120px)]"
    />
  );
};

export default observer(EnergyDashboard);
